<template>
	<div class="min_cw padding_xl_lr">
		<HomeTitleItem title="新闻动态" sub="NEWS INFORMATION" />

		<ul class="home_new_list">
			<li v-for="(item, index) in list" :key="item.news_id" :class="index < 2 ? 'left' : 'right'" @click="itemClick(item, index)">
				<div class="img_box">
					<img class="img" :src="$http.fileUrl + item.news_pic" alt="">
				</div>
				<div class="con">
					<p class="title">{{ item.news_title }}</p>
					<p class="date">{{ $formatDate(item.create_time, "date") }}</p>
				</div>
			</li>
		</ul>

		<HomeMoreBtn @click="handleMore" />
	</div>
</template>

<script>
import HomeTitleItem from './titleItem'
import HomeMoreBtn from './moreBtn'
import {getNewsListApi} from "@/api";

export default {
	name: "index",
	components: {
		HomeTitleItem,
		HomeMoreBtn,
	},
	data() {
		return {
			loading: false,
			queryParams: {
				// orderContent: "create_time desc",
				pageNum: 1,
				pageSize: 4,
			},
			list: [],
		}
	},
	created() {
		// this.getList();
	},
	methods: {
		async getList() {
			this.loading = true;
			return new Promise(async resolve => {
				const res = await getNewsListApi(this.queryParams);
				this.list = res.rows;
				this.loading = false;
				resolve(true)
			})

		},

		itemClick(item, index) {
			this.$router.push("/news/" + item.news_id);
		},

		handleMore() {
			this.$router.push("/news");
		}
	}
}
</script>

<style lang="less" scoped>
.home_new_list {
	width: 100%;
	display: flex;
	overflow: hidden;

	>li {
		flex-shrink: 0;
		width: calc(25% - 30px);
		margin-left: 30px;
		border: 1px solid @greyLine;
		cursor: pointer;
		position: relative;
		transition: all 1s;
	}

	>li:first-of-type {
		margin-left: 0;
	}

	.left {
		left: 0;
	}

	.right {
		right: 0;
	}

	.img_box {
		width: 100%;
		height: 0;
		padding-top: calc(100% / 1.66);
		position: relative;
		overflow: hidden;

		.img {
			width: 100%;
			height: 100%;
			object-fit: cover;
			position: absolute;
			top: 0;
			left: 0;
			transition: all .3s;
		}
	}

	.img_box:hover .img {
		transform: scale(1.2);
	}

	.con {
		width: 100%;
		height: 140px;
		padding: 24px 30px;
		background-color: @white;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		transition: all .3s;
		font-size: 16px;

		.title {
			color: @gray;
			.ellipsis2;
			line-height: 1.6;
		}

		.date {
			color: @red;
			.ellipsis;
			margin-top: 14px;
		}
	}
}



@media screen and (max-width: 1180px) {
	.home_new_list {
		.con {
			height: 100px;
			padding: 15px 20px;
			font-size: 14px;
		}
	}
}



@media screen and (max-width: 900px) {
	.home_new_list {
		.con {
			height: 90px;
			padding: 10px;
		}
	}
}
</style>
